import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../Util';

/** renders a div that styles contained headers/sections */
const Wrapper = props => {
  const { children, className, style } = props
  return (
    <div className={formatClassName(['wrapper', className])} style={style}>
      {children}
    </div>
  )
}

Wrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Wrapper;
